// Barra de filtros: a busca e os seletores que abrem quase toda listagem
// do painel.
//
// Virou peça porque cada tela montava a sua: uma com o campo de busca
// largo e os seletores embaixo, outra com tudo na mesma linha, outra com o
// rótulo em cima. Nenhuma estava errada e o conjunto parecia remendado.
//
// A busca fica sempre primeiro e ocupa o espaço que sobra; os seletores
// vêm à direita com largura fixa, porque o nome da opção mais longa é
// conhecido e não precisa de espaço elástico.

import { BRANCO, TEXTO, CINZA_ESC, BORDA, BORDA_FORTE, RAIO, ESP } from "../tema";
import Icone from "./Icone";

export function CampoDeBusca({ valor, onChange, placeholder = "Buscar...", style = {} }) {
  return (
    <div style={{ position: "relative", flex: "1 1 240px", minWidth: 180, ...style }}>
      <span style={{ position: "absolute", left: 13, top: "50%", transform: "translateY(-50%)", color: "#94A3B8", pointerEvents: "none" }}>
        <Icone nome="busca" tamanho={17} />
      </span>
      <input
        type="search" value={valor} onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          width: "100%", boxSizing: "border-box",
          border: `1px solid ${BORDA_FORTE}`, borderRadius: RAIO.md,
          padding: "11px 14px 11px 39px", fontSize: 13.5, fontFamily: "inherit",
          color: TEXTO, background: BRANCO, outline: "none",
        }}
      />
    </div>
  );
}

// Seletor da barra: sem rótulo acima, porque a própria opção escolhida já
// diz o que é ("Todos os perfis", "Todos os núcleos").
export function SeletorDeFiltro({ valor, onChange, opcoes, largura = 200, style = {} }) {
  return (
    <select
      value={valor} onChange={e => onChange(e.target.value)}
      style={{
        flex: `0 1 ${largura}px`, minWidth: 150, boxSizing: "border-box",
        border: `1px solid ${BORDA_FORTE}`, borderRadius: RAIO.md,
        padding: "11px 12px", fontSize: 13.5, fontFamily: "inherit",
        color: TEXTO, background: BRANCO, cursor: "pointer", outline: "none",
        ...style,
      }}
    >
      {opcoes.map(o => {
        const v = typeof o === "string" ? o : o.value;
        const r = typeof o === "string" ? o : o.label;
        return <option key={v} value={v}>{r}</option>;
      })}
    </select>
  );
}

export default function BarraDeFiltros({ children, style = {} }) {
  return (
    <div style={{
      display: "flex", gap: ESP.md, flexWrap: "wrap", alignItems: "center",
      paddingBottom: ESP.lg, borderBottom: `1px solid ${BORDA}`, marginBottom: 0,
      ...style,
    }}>
      {children}
    </div>
  );
}

// Nota de rodapé de listagem: "Mostrando 1 a 6 de 6 usuários" à esquerda e
// a paginação à direita. Sem a contagem, uma lista cortada em vinte linhas
// parece a lista inteira, e quem procura alguém desiste achando que a
// pessoa não está cadastrada.
export function RodapeDeLista({ inicio, fim, total, unidade = "registros", children }) {
  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "space-between",
      gap: ESP.md, flexWrap: "wrap", paddingTop: ESP.lg, marginTop: ESP.lg,
      borderTop: `1px solid ${BORDA}`,
    }}>
      <div style={{ fontSize: 12.5, color: CINZA_ESC }}>
        {total > 0
          ? <>Mostrando <strong style={{ color: TEXTO, fontWeight: 600 }}>{inicio}</strong> a <strong style={{ color: TEXTO, fontWeight: 600 }}>{fim}</strong> de <strong style={{ color: TEXTO, fontWeight: 600 }}>{total}</strong> {unidade}</>
          : <>Nenhum registro</>}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: ESP.sm }}>{children}</div>
    </div>
  );
}
